<template>
<div id="stocks">
    <div class="main_block">
        <h1>Акции и подарки для наших автовладельцев</h1>
    </div>
    <div class="wrapper">
        <div id="conext" class="container">
                <div class="col-md-40" v-for="(stock, key) in stocks" :key="key">
                    <div class="logo">
                        <div><img :src="stock.logo" alt="" :style = "{maxwidth:'70px',maxHeight:'70px'}"></div>
                        <div><router-link to="#">все акции товара</router-link></div>
                    </div>
                    <div class="thumbnail clearfix">
                        <div class="img_conteinr " :style = "{background:'url('+stock.img+') no-repeat center',width:'128px',height:'128px',backgroundSize:'cover'}" >

                        </div>
                        <h4>{{stock.title}}</h4>
                        <p><span>до конца акции:</span> <b class="otshet">{{stock.time.h}}:{{stock.time.m}}:{{stock.time.s}}</b></p>
                        <router-link :to="'/acii/'+stock.id+'/'"><img src="/static/img/general/acii/icon.png" alt=""></router-link>
                    </div>
                </div>
        </div>
    </div>
    <div class="row" style="margin: 40px;">
        <div class="col-md-120" style="text-align:center;">
            <button id="btnnext" class="btn btn_next" >показать все</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'stocks',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      stocks: [
        {
          id: 11,
          logo: 'https://xn----8sbecarw9btief.xn--p1ai/uploads/2019/03/18/12/03/f5987423f13ffcf5f44948e67c9bc51b.jpg',
          img: 'https://xn----8sbecarw9btief.xn--p1ai/uploads/2019/03/18/12/03/f5987423f13ffcf5f44948e67c9bc51b.jpg',
          title: 'Владельцам карты Пятерочка',
          time: {
            h: 0,
            m: 0,
            s: 0
          }
        },
        {
          id: 7,
          logo: 'https://xn----8sbecarw9btief.xn--p1ai/uploads/2018/10/14/18/21/e2a90a8082aea2e310ea5b8b5b1e3429.jpg',
          img: 'https://xn----8sbecarw9btief.xn--p1ai/uploads/2018/10/14/18/21/e2a90a8082aea2e310ea5b8b5b1e3429.jpg',
          title: 'Сезонное хранение резины 1799 руб. до 1000 руб можно оплатить бонусными рублями',
          time: {
            h: 0,
            m: 0,
            s: 0
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
    .thumbnail>img {
        margin-left: 0;
        margin-right: 0;
    }

    .img_conteinr{
        float: left;
        margin-right: 15px;
    }

    .img_conteinr>img{
        width: 128px;
        float: left;
        margin-right: 15px;
    }
    .thumbnail>h4 {
        font-size: 15pt;
    }
    .thumbnail{
        padding: 0;
        position: relative;
        font-color:#3a3a3a;
    }
    .thumbnail>p{
        position: absolute;
        bottom: 0;
        left: 140px;
        font-size:10pt;
        padding: 1px;
    }
    .thumbnail>p>b{
        font-size:11pt;
        padding-top: 4px;
    }
    .thumbnail>p>span{
        padding-bottom: 4px;
    }
    .main_block{
        text-align: center;
        width: 100%;
        padding: 1px;
        background: url(/static/img/general/acii/foto_heder.jpg) no-repeat;
        background-size: 100%;
        position: relative;
    }
    .main_block>h1{
        font-family: "OpenSansBold", sans-serif;
        color: #fff;
        margin: 51px 0 ;

    }
    .thumbnail>a{
        display: block;
        position: absolute;
        bottom: 12px;
        right: 12px;

    }
    .logo div{
        text-align: center;

    }
    .logo div{
        margin: 10px 0;
    }
    .logo a{
        text-decoration: underline;
    }
    .btn_next{
        color: #fff;
        background-image: linear-gradient(to top, #274c7c 0%, #4a80c6 100%);
        padding: 10px 30px;
        z-index: 1;
        position: relative;
        border-radius: 0;
        text-decoration: none;
        font-size: 16px;
    }

    .btn_next:hover{
        text-decoration: none;
        background-image: none;
        background-color: #4575b3;
        outline: 0;
        color: #fff;
    }
    .btn_next:focus{
        color: #fff;
        background-image: linear-gradient(to top, #274c7c 0%, #4a80c6 100%);
        padding: 10px 30px;
        z-index: 1;
        position: relative;
        text-decoration: none;
    }

    .description{
        font-family: "OpenSansLight", sans-serif;
        color:#3a3a3a;
        line-height: 20px;
        margin-bottom: 50px;
        font-size: 16px;
    }
    .description p {
        display: block;
        -webkit-margin-before: 1em;
        -webkit-margin-after: 1em;
        -webkit-margin-start: 0px;
        -webkit-margin-end: 0px;
    }
    .zagol{
        font-family: "OpenSansLight", sans-serif;
        color:#3a3a3a;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Stocks.vue